// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ka-6";
export var imgContainer = "_ka-3";
export var menuIcon = "_ka-5";
export var pillWrapper = "_ka-2";
export var pillsContainer = "_ka-1";
export var subscriptionCard = "_ka-0";
export var subscriptionLogo = "_ka-4";